import { render, staticRenderFns } from "./MesaDirectiva.vue?vue&type=template&id=3e0a7432&scoped=true&"
import script from "./MesaDirectiva.vue?vue&type=script&lang=js&"
export * from "./MesaDirectiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a7432",
  null
  
)

export default component.exports